import { useIntl } from 'react-intl'

export default function useFormatMessage() {
  const intl = useIntl()

  return intl.formatMessage
}
